module.exports = __webpack_public_path__ + "static/media/bg_3.bc761fc9.jpg";